var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.status !== this.userStatusToExclude)?_c('b-button',{attrs:{"type":"button","size":"sm","variant":"success"},on:{"click":_vm.activateUser}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Activate\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }